import {Component, OnDestroy, OnInit} from '@angular/core';
import {SuggestionListsService} from '../../services/suggestion-lists.service';
import {ComponentBackgroundService} from '../../../../../services/component-background.service';
import {UserService} from '../../../../../services/user.service';
import {AdminService} from '../../../../../services/admin.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationPopupComponent} from '../../../../views/view-group/popups/confirmation-popup/confirmation-popup.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../../../models/user.model';
import { ToastService } from '../../../../../services/toast.service';

enum ValidationConstants {
  MIN_DESCRIPTION_LENGTH = 3,
  MAX_TEMPLATE_LENGTH = 80
}

enum HttpStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  NOT_FOUND = 404
}

@Component({
  selector: 'app-create-new-slist',
  templateUrl: './create-new-slist.component.html',
  styleUrls: ['./create-new-slist.component.css']
})
export class CreateNewSlistComponent implements OnInit, OnDestroy {
  readonly MIN_DESCRIPTION_LENGTH = ValidationConstants.MIN_DESCRIPTION_LENGTH;

  editMode = false;               // Check if edit mode activated
  draftForEdit = null;            // Draft for edit from SuggestionListsService
  standardTemplate = null;        // For get ID and Name of initiator standard

  draftId: string;                // Use if draft was opened
  initiatorUser = null;           // Use for ID and showing name of user
  initiatorDivision = null;       // groupId

  isLoaded = false;               // Show spinner while info is loading
  responseMessage: string;        // Set error message text here
  showErrorMsg = false;           // Show or hide error message
  showSuccessMsg = false;         // Show or hide error message

  allBtnsIsDisabled = false;      // Disable all buttons
  savedSLorDraft = {              // Temp object for canLeavePage()
    template: '',
    description: ''
  };

  isAdmin = false;
  isUser = false;
  isHead = false;

  internalServerError = false;
  getGroupError = false;
  getSelfError = false;
  id;
  thisDraft;
  groups = [];
  selectDepartment;
  currentUser; 
  user: User;
  previewText: string = '';
  isTooLong: boolean = false;
  photoError: string = '';

  // Properties to track hover state and validation highlighting
  isSaveButtonHovered = false;
  highlightDescription = false;
  highlightPreview = false;

  constructor(public suggestionListsService: SuggestionListsService,
              public componentBackgroundService: ComponentBackgroundService,
              private userService: UserService,
              private adminService: AdminService,
              private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private toastService: ToastService) {              
    this.id = this.route.snapshot.params['id'];
  }

  checkLength() {
    this.isTooLong = this.suggestionListsService.templateService.trim().length > ValidationConstants.MAX_TEMPLATE_LENGTH;
  }

  functionToRun(e) {
    const confirmationMessage = '\o/';
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  }


  ngOnDestroy() {
    window.removeEventListener('beforeunload', this.functionToRun);

    if (!this.canLeavePage()) {
      this.onSaveDraftAction();
      alert('You have unsaved changes. The Suggestion List is saved as a Draft.');
    }
  }

  getAllGroupForList() {
		this.adminService.getAllGroups().subscribe(
			(response: any) => {
				this.groups = response.body;
			},
		);
	}


  canLeavePage() {
    return this.savedSLorDraft.template.trim() === this.suggestionListsService.templateService.trim() &&
      this.savedSLorDraft.description.trim() === this.suggestionListsService.descriptionService.trim();
  }

  disableSaveBtn() {
    return (this.suggestionListsService.descriptionService.trim().length < ValidationConstants.MIN_DESCRIPTION_LENGTH || 
            this.suggestionListsService.templateService.trim().length < ValidationConstants.MIN_DESCRIPTION_LENGTH ||
            this.suggestionListsService.templateService.trim().length > ValidationConstants.MAX_TEMPLATE_LENGTH);
  }

  ngOnInit() {
    this.checkRole();
    this.currentUser = JSON.parse(localStorage.getItem('User'));
    this.getAllGroupForList();
    window.addEventListener('beforeunload', this.functionToRun);
    // Set default values
    this.internalServerError = false;
    this.getGroupError = false;
    this.getSelfError = false;

    this.isLoaded = false;
    this.responseMessage = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;
    this.editMode = false;
    this.photoError = '';

    // Init temp object
    this.savedSLorDraft.template = this.suggestionListsService.templateService;
    this.savedSLorDraft.description = this.suggestionListsService.descriptionService;

    // EDIT MODE
    if (this.suggestionListsService.getListType() === 'edit') {
      this.editMode = true;
      // Check if SL service has a Draft
      if (this.suggestionListsService.hasDraft()) {
        // Get Draft from SL service
        this.draftForEdit = this.suggestionListsService.getDraft();
        // Set values
        this.draftId = this.draftForEdit.id;
        this.initiatorUser = this.draftForEdit.initiator; // id, firstName, lastName
        this.initiatorDivision = this.draftForEdit.group; // id, name

        this.suggestionListsService.templateService = this.draftForEdit.template;
        this.suggestionListsService.descriptionService = this.draftForEdit.description;

        // Init temp object
        this.savedSLorDraft.template = this.suggestionListsService.templateService;
        this.savedSLorDraft.description = this.suggestionListsService.descriptionService;

        // Clear standardTemplate
        this.standardTemplate = null;
        this.isLoaded = true;

      } else {
        this.responseMessage = 'Edit Mode is enabled but we can not get Draft of this Suggestion List';
        this.showErrorMsg = true;
        this.isLoaded = true;
      }

      // FREE OR STANDARD MODE
    } else {
      // Set empty default values
      this.suggestionListsService.descriptionService = '';
      this.suggestionListsService.photosService = [];
      this.suggestionListsService.photoUrlsService = [];

      // Init temp object
      this.savedSLorDraft.description = this.suggestionListsService.descriptionService;

      // Get self (get initiator user)
      // GET SELF ERROR
      this.userService.getUserFromAPI(this.userService.getLocal().id).subscribe(
        (res: any) => {
          if (res.status === HttpStatus.OK) {
            this.initiatorUser = res.body;

            this.internalServerError = false;
            this.getGroupError = false;
            this.getSelfError = false;

            // Get initiator group
            // GET MAIN GROUP BY MAIN GROUP ID ERROR
            this.adminService.getGroupByID(this.initiatorUser.mainGroup).subscribe(
              (response: any) => {
                if (response.status === HttpStatus.OK) {
                  this.initiatorDivision = response.body;
                  this.selectDepartment = this.initiatorDivision.id;
                  this.internalServerError = false;
                  this.getGroupError = false;
                  this.getSelfError = false;

                  // Check SL type
                  if (this.suggestionListsService.getStandard()) {
                    this.standardTemplate = this.suggestionListsService.getStandard();
                    this.suggestionListsService.templateService = 'Standard ' + this.standardTemplate.number;
                    this.isLoaded = true;
                  } else {
                    this.suggestionListsService.templateService = '';
                    // Init temp object
                    this.savedSLorDraft.template = this.suggestionListsService.templateService;
                    this.isLoaded = true;
                  }

                } else if (response.status === HttpStatus.NO_CONTENT) {
                  this.internalServerError = true; // ***
                  this.getGroupError = true; // ***
                  this.getSelfError = false;

                  this.isLoaded = true;
                } else {
                  this.internalServerError = true; // ***
                  this.getGroupError = true; // ***
                  this.getSelfError = false;

                  this.isLoaded = true;
                }
              },
              () => {
                this.internalServerError = true; // ***
                this.getGroupError = true; // ***
                this.getSelfError = false;

                this.isLoaded = true;
              }
            );

          } else {
            this.internalServerError = true; // ***
            this.getGroupError = false;
            this.getSelfError = true; // ***

            this.isLoaded = true;
          }
        },
        () => {
          this.internalServerError = true; // ***
          this.getGroupError = false;
          this.getSelfError = true; // ***

          this.isLoaded = true;
        }
      );
    }

  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }


  // Check if Draft is valid
  isDraftValid() {
    return this.initiatorUser !== null &&
      this.initiatorDivision !== null &&
      this.suggestionListsService.descriptionService.length >= this.MIN_DESCRIPTION_LENGTH;
  }

  // Cancel button pressed
  onCancelAction() {
    // TODO проверять событие закрытия вкладки или перехода на другой URL!
    // https://stackblitz.com/edit/angular-rgsa51
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'Unsaved data will be lost. Continue?';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.responseMessage = '';
        this.showErrorMsg = false;
        this.showSuccessMsg = false;
        // Go to my suggestion lists
        this.router.navigate(['/dashboard/my-suggestion-lists']);
      }
    });
  }

  onDepartmentChange(id): void {
    this.selectDepartment = id;
  }

  onPhotoSelect(event: any) {
    const files = event.target.files;
    this.photoError = '';
    
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      
      if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
        this.photoError = 'ERROR_PHOTO_TYPE';
        continue;
      }
      
      if (!this.suggestionListsService.addPhoto(file)) {
        this.photoError = 'ERROR_PHOTO_LIMIT';
        break;
      }
    }
    
    event.target.value = '';
  }

  removePhoto(index: number) {
    this.suggestionListsService.removePhoto(index);
    this.photoError = '';
  }
  // Save Draft button pressed
  // Do not check if Draft is valid here
  onSaveDraftAction() {
    // TODO add disable state controller for all buttons
    this.responseMessage = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;

    this.allBtnsIsDisabled = true;

    if (this.suggestionListsService.getListType() === 'edit' &&
      this.suggestionListsService.hasDraft()) {
      // UPDATE DRAFT
      const updatedDraft = {
        id: this.draftId,
        template: this.suggestionListsService.templateService,
        description: this.suggestionListsService.descriptionService
      };

      // Init temp object
      this.savedSLorDraft.template = this.suggestionListsService.templateService;
      this.savedSLorDraft.description = this.suggestionListsService.descriptionService;

      if (updatedDraft.template.trim().length === 0) {
        updatedDraft.template = null;
      }

      this.suggestionListsService.updateDraft(updatedDraft).subscribe(
        (res: any) => {
          if (res.status === HttpStatus.OK || res.status === HttpStatus.CREATED) {
            this.responseMessage = 'Draft was successfully edited and saved';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.allBtnsIsDisabled = false;
          } else {
            this.responseMessage = 'Error editing and saving this Draft';
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.allBtnsIsDisabled = false;
          }
        },
        () => {
          this.responseMessage = 'Error editing and saving this Draft';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.allBtnsIsDisabled = false;
        }
      );

    } else {
      // CREATE DRAFT
      const thisDraft = {
        groupId: this.initiatorDivision.id,
        template: this.suggestionListsService.templateService,
        description: this.suggestionListsService.descriptionService
      };

      // Init temp object
      this.savedSLorDraft.template = this.suggestionListsService.templateService;
      this.savedSLorDraft.description = this.suggestionListsService.descriptionService;

      if (thisDraft.template.trim().length === 0) {
        thisDraft.template = null;
      }

      const requestData = this.suggestionListsService.createFormDataWithPhotos(thisDraft);

      this.suggestionListsService.addNewDraft(requestData).subscribe(
        (res: any) => {
          if (res.status === HttpStatus.CREATED || res.status === HttpStatus.OK) {
            this.responseMessage = 'Draft was successfully saved';
            this.showErrorMsg = false;
            this.showSuccessMsg = true;
            this.allBtnsIsDisabled = false;
          } else {
            this.responseMessage = 'Error saving this Draft';
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.allBtnsIsDisabled = false;
          }

        },
        () => {
          this.responseMessage = 'Error saving this Draft';
          this.showErrorMsg = true;
          this.showSuccessMsg = false;
          this.allBtnsIsDisabled = false;
        }
      );

    }

  }

  // Save and Send for review button pressed
  onSendForReviewlAction() {
    // TODO add disable state controller for all buttons
    this.responseMessage = '';
    this.showErrorMsg = false;
    this.showSuccessMsg = false;

    // If draft is valid
    if (this.isDraftValid()) {
      // DONE, SEND FOR REVIEW
      this.allBtnsIsDisabled = true;

      if(this.id) {
        this.thisDraft = {
          name: this.suggestionListsService.templateService,
          description: this.suggestionListsService.descriptionService
        };
      } else {
        if(this.isHead && this.isAdmin && this.currentUser.mainGroup === '62a311f4bff1153571181b36') {
          this.thisDraft = {
            groupId: this.selectDepartment,
            name: this.suggestionListsService.templateService,
            description: this.suggestionListsService.descriptionService
          };
        } else {
          this.thisDraft = {
            name: this.suggestionListsService.templateService,
            description: this.suggestionListsService.descriptionService
          };
        }
      }
      if (this.suggestionListsService.templateService.trim().length === 0) {
        this.thisDraft.name = null;
      }

      // Init temp object
      this.savedSLorDraft.template = this.suggestionListsService.templateService;
      this.savedSLorDraft.description = this.suggestionListsService.descriptionService;

      if(this.id) {
        const requestData = this.suggestionListsService.createFormDataWithPhotos(this.thisDraft);
        
        this.suggestionListsService.addNewMist(this.id, requestData).subscribe(
          (res: any) => {
            if (res.status === HttpStatus.CREATED || res.status === HttpStatus.OK) {
              this.responseMessage = 'Suggestion List was successfully saved and sent for review';
              this.showErrorMsg = false;
              this.showSuccessMsg = true;
              this.allBtnsIsDisabled = false;
  
              // Show message
              this.suggestionListsService.showSuccessMsgOnSLList = true;
              this.router.navigate(['/dashboard/my-suggestion-lists']);
  
            } else {
              this.responseMessage = 'Error saving and sending this Suggestion List';
              this.showErrorMsg = true;
              this.showSuccessMsg = false;
              this.allBtnsIsDisabled = false;
            }
  
          },
          (err) => {
            if(err.status === HttpStatus.NOT_FOUND) {
              this.responseMessage = 'You can not create suggestion lists because there is no Head in the department';
            } else {
              this.responseMessage = 'Error saving and sending this Suggestion List';
            }
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.allBtnsIsDisabled = false;
          }
        );
      } else {
        const requestData = this.suggestionListsService.createFormDataWithPhotos(this.thisDraft);
        
        this.suggestionListsService.addNewSL(requestData).subscribe(
          (res: any) => {
            if (res.status === HttpStatus.CREATED || res.status === HttpStatus.OK) {
              this.allBtnsIsDisabled = false;
  
              // Show message
              this.suggestionListsService.showSuccessMsgOnSLList = true;
              this.router.navigate(['/dashboard/my-suggestion-lists']);
  
            } else {
              this.responseMessage = 'Error saving and sending this Suggestion List';
              this.showErrorMsg = true;
              this.showSuccessMsg = false;
              this.allBtnsIsDisabled = false;
            }
  
          },
          (err) => {
            if(err.status === HttpStatus.NOT_FOUND) {
              this.responseMessage = 'You can not create suggestion lists because there is no Head in the department';
            } else {
              this.responseMessage = 'Error saving and sending this Suggestion List';
            }
            this.showErrorMsg = true;
            this.showSuccessMsg = false;
            this.allBtnsIsDisabled = false;
          }
        );
      }
   

    } else {
      // Draft is invalid
      this.responseMessage = 'If you want to send this Suggestion List for review, enter a Description ' +
        '(must be at least 3 characters) or save it as Draft to continue later.';
      this.showErrorMsg = true;
    }
  }

  
  // Methods to handle save button hover
  onSaveButtonMouseEnter() {
    this.isSaveButtonHovered = true;
    this.updateFieldHighlights();
  }

  onSaveButtonMouseLeave() {
    this.isSaveButtonHovered = false;
    this.highlightDescription = false;
    this.highlightPreview = false;
  }

  // Method to update field highlights based on validation
  updateFieldHighlights() {
    this.highlightDescription = (
      !this.suggestionListsService.descriptionService || 
      this.suggestionListsService.descriptionService.trim().length < this.MIN_DESCRIPTION_LENGTH
    );
    
    this.highlightPreview = (
      !this.suggestionListsService.templateService || 
      this.suggestionListsService.templateService.trim().length < this.MIN_DESCRIPTION_LENGTH
    );
  }

}




// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/suggestion-lists/components/create-new-slist/create-new-slist.component.ts